import { createDialogProvider } from "src/components/Dialog";
import { UpdateEligibilityDialogContext } from "./context";
import { UpdateEligibilityDialog } from "./UpdateEligibilityDialog";

export const { DialogProvider: UpdateEligibilityDialogProvider } =
  createDialogProvider(
    UpdateEligibilityDialogContext,
    UpdateEligibilityDialog,
    "UpdateEligibilityDialog"
  );
